import useStoreStore from '@/store/modules/store'
import useUserStore from '@/store/modules/user'

export const userlogIn = async (data: any) => {
  const userStore = useUserStore()
  const storeStore = useStoreStore()
  userStore.setUserInfo(data)
  storeStore.clearStores()
  localStorage.setItem('userInfo', JSON.stringify(data))
  localStorage.removeItem('hasError401')
}
